const checkAccess = (moduleName, userDetails) => {
  if (!userDetails || !userDetails.AccessDetails) {
    return false;
  }

  return userDetails.AccessDetails.some(
    (accessDetail) => accessDetail.ModuleName === moduleName
  );
};

const getAccessibleRoutes = (routes) => {
  const storedUserDetails = localStorage.getItem('userDetails');
  const userDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;

  if (!userDetails) { return [];}

  return routes.filter((route) => {
    const moduleName = route.moduleName;
    return checkAccess(moduleName, userDetails);
  });
};

export { getAccessibleRoutes };
